import datos from "src/services/datos";

const estados = new datos("tipo_cajas");
export const getTipoCaja = async () => {
  estados.addCondition("tipo_cajas", "id", 0, ">");
  const response = await estados.get();
  return response.wsResponse.tipo_cajas;
};
